import { createContext } from 'react';

const RootContextStore = createContext({
  addMessage: () => { },
});

export default RootContextStore;